import { useContext, useEffect, useRef } from 'react';
import { Guid } from 'guid-typescript';

import { LoadingAnimationContext } from './LoadingAnimationContext';


export function useLoadingAnimation() {
  const instanceId = useRef(Guid.create().toString()).current;
  const context = useContext(LoadingAnimationContext);

  if (typeof context === 'undefined') {
    throw new Error('useLoadingAnimation must be within LoadingAnimationProvider');
  }

  const toggleLoadingAnimation = (isVisible: boolean) => {
    context.toggleLoadingAnimation(isVisible, instanceId);
  };

  useEffect(() => () => {
    context.toggleLoadingAnimation(false, instanceId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    toggleLoadingAnimation,
    isVisibleLoadingAnimation: context.isVisibleLoadingAnimation,
    id: instanceId,
  };
}
